var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2619 10.9524H18.619V6.57143C18.619 5.99048 18.3883 5.43332 17.9775 5.02253C17.5667 4.61173 17.0095 4.38095 16.4286 4.38095H12.0476V2.7381C12.0476 2.01191 11.7591 1.31546 11.2456 0.80197C10.7322 0.288477 10.0357 0 9.30952 0C8.58334 0 7.88689 0.288477 7.3734 0.80197C6.85991 1.31546 6.57143 2.01191 6.57143 2.7381V4.38095H2.19048C1.60953 4.38095 1.05237 4.61173 0.641576 5.02253C0.230782 5.43332 0 5.99048 0 6.57143V10.7333H1.64286C3.28571 10.7333 4.6 12.0476 4.6 13.6905C4.6 15.3333 3.28571 16.6476 1.64286 16.6476H0V20.8095C0 21.3905 0.230782 21.9476 0.641576 22.3584C1.05237 22.7692 1.60953 23 2.19048 23H6.35238V21.3571C6.35238 19.7143 7.66667 18.4 9.30952 18.4C10.9524 18.4 12.2667 19.7143 12.2667 21.3571V23H16.4286C17.0095 23 17.5667 22.7692 17.9775 22.3584C18.3883 21.9476 18.619 21.3905 18.619 20.8095V16.4286H20.2619C20.9881 16.4286 21.6845 16.1401 22.198 15.6266C22.7115 15.1131 23 14.4167 23 13.6905C23 12.9643 22.7115 12.2678 22.198 11.7544C21.6845 11.2409 20.9881 10.9524 20.2619 10.9524Z",
    fill: "#00875E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.faf15203f6eec2706bab8a55671c3d09.svg";
export { ForwardRef as ReactComponent };